/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Rewards_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"RewardsNav_viewer">;
    readonly " $refType": "Rewards_viewer";
};
export type Rewards_viewer$data = Rewards_viewer;
export type Rewards_viewer$key = {
    readonly " $data"?: Rewards_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Rewards_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Rewards_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RewardsNav_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2c3f1ed0bc3efde6d8c3c59f5181a6a2';
export default node;
